import moment from 'moment-timezone'

class momentHelper {
  static getCurrentDate () {
    return moment().format('YYYY-MM-DD')
  }
  static getDateTime (date) {
    return moment(date).format('YYYY-MM-DD h:mm:ss A')
  }
  static getDate (date) {
    return moment(date).format('YYYY-MM-DD')
  }
  static getTime (date) {
    return moment(date).format('h:mm:ss A')
  }
  static getTimeAgo (date, locale = 'en') {
    // TODO: Put globally? or put in a helper function, or constructor for moment
    moment.locale('kr', {
      relativeTime: {
        past (input) {
          return input === 'just now' ? input : `${input  } 전`
        },
        s: '방금',
        future: 'in %s',
        ss: '%d 초',
        m: '%d 분',
        mm: '%d 분',
        h: '%d 시간',
        hh: '%d 시간',
        d: 'a 일',
        dd: '%d 일',
        M: 'a 개월',
        MM: '%d 개월',
        y: 'a 년',
        yy: '%d 년'
      }
    })
    return moment.tz(date, 'Asia/Seoul').tz(moment.tz.guess()).locale(locale).fromNow()
  }
}

export default momentHelper
